import React, { Component } from 'react';
import { Button, Select, DatePicker } from 'antd';
import SelectProvince from '../../../common/SelectProvince';
import SearchRetrieve from '../../../common/SearchRetrieve.new.js';
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';
import moment from 'moment';

const { Option } = Select;
const monthFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker;

class Filter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            render: true,
            positionList: [],
        }
    }

    componentDidMount() {
        this.queryPositionByType();
    }

    queryPositionByType = () => {
        Fetch.post(API_URL.home.queryPositinoByType, {
            type: 'TEACHER_POSITION'
        }).then(res => {
            const { data } = res;
            this.setState({ positionList: data });
        });
    }

    search = () => {
        this.props.onSearch();
    }

    export = () => {
        this.props.onExport();
    }

    reset = () => {
        this.setState({ render: false }, () => {
            this.setState({ render: true });
        });
        this.props.onReset();
    }

    handleChange = (value, key) => {
        const { searchParams, onChange } = this.props;
        switch (key) {
            case 'province': {
                const areaParams = {};
                const areaList = [];
                const hasCheckedArea = [];
                value.forEach(item => {
                    const { key, props: { title } = {} } = item || {};
                    areaParams[`params[${title}]`] = key;
                    areaList.push(title);
                    hasCheckedArea.push(key);
                });
                searchParams.areaParams = areaParams;
                searchParams.hasCheckedArea = hasCheckedArea;
                searchParams.areaName = areaList.join(',');
                break;
            }
            case 'user': {
                const { value: id, text: name } = value;
                searchParams.userId = id;
                searchParams.userName = name;
                break;
            }
            default:
                searchParams[key] = value;
                break;
        }
        onChange(searchParams);
    }

    disabledDate = (current) => {
        const { maxDate } = this.props;
        const minValue = moment('2021-12').valueOf();
        const value = moment(maxDate).add(1, 'M').valueOf();
        const month = current.month();
        return (
            current &&
            !(
                current.valueOf() >= minValue &&
                current.valueOf() <= value &&
                (month === 5 || month === 11)
            )
        );
    }

    render () {
        const { curRole } = sessionStorage;
        const { searchParams } = this.props;
        const { render, positionList } = this.state;
        const begin = searchParams.date ? moment(searchParams.date) : null;
        const positionOptions = positionList.map(i => <Option key={i.positionName}>{i.positionName}</Option>);
        return (
            <div className="search-bar" style={{ marginTop: 10 }}>
                <div className="search-item">
                    <label className="ui-label">时间</label>
                    <MonthPicker
                        format={monthFormat}
                        allowClear={false}
                        value={begin}
                        style={{width: 90}}
                        disabledDate={this.disabledDate}
                        onChange={(date, dateString) => this.handleChange(dateString, 'date')}
                    />
                </div>
                <div className="search-item">
                    <label className="ui-label">区域/城市</label>
                    {
                        render &&
                        <SelectProvince
                            areaName={searchParams.areaName}
                            hasCheckedArea={searchParams.hasCheckedArea}
                            saveProvince={value => this.handleChange(value, 'province')}
                        />
                    }
                </div>
                <div className="search-item">
                    <label className="ui-label">职位级别</label>
                    <Select
                        allowClear={true}
                        placeholder="请选择"
                        style={{ width: 120 }}
                        value={searchParams.positionName}
                        onChange={value => this.handleChange(value, 'positionName')}
                    >
                        {positionOptions}
                    </Select>
                </div>
                <div className="search-item">
                    <label className="ui-label">人员</label>
                    <SearchRetrieve
                        keyword='keyword'
                        style={{ width: 162 }}
                        params={{ limit: 20 }}
                        placeholder="输入姓名/工号检索"
                        value={searchParams.userName}
                        url={API_URL.investigation.queryUserByKey}
                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                        onChange={option => this.handleChange(option, 'user')}
                    />
                </div>
                <div className="search-item">
                    <Button type="primary" onClick={this.search}>搜索</Button>
                    { curRole !== 'CRC' && <Button type="primary" onClick={this.export}>导出</Button> }
                    <Button type="primary" onClick={this.reset}>重置</Button>
                </div>
            </div>
        );
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/home/TeachingRank/components/Filter.js